const host = "system.nacellegrooves.com";
const baseUrl = `https://${host}/api/v1`;
export const socketUrl = `wss://${host}/ws/vendor`;

export const routes = {
  listAds: `${baseUrl}/ads/`,
};
